import React, { FC } from "react";
import { DATE_FORMAT, IScheduleMonth, months } from "../../../utils";
import { format } from "date-fns";
import { Day } from "./Day";
import '../../../styles/components/calendar/schedule/day.scss';

interface MonthProps {
  monthSchedule: IScheduleMonth;
  todayString: string;
  openMeeting: (id: number, calendarId: number, start?: Date, end?: Date) => void
}

export const Month: FC<MonthProps> = ({ monthSchedule, todayString, openMeeting }) => {
  const monthName = months[monthSchedule.months % 12];
  const year = Math.floor(monthSchedule.months / 12);

  return (
    <>
      <p className="month">{`${monthName} ${year}`}</p>
      {monthSchedule.monthMeetings.map((day) => (
        <Day 
          isToday={format(day.date, DATE_FORMAT) === todayString}
          key={+day.date} 
          meetings={day.meetings} 
          date={day.date}
          onOpenMeeting={openMeeting}
        />
      ))}
      {monthSchedule.monthMeetings.length === 0 && <p>Встреч в этом месяце нет</p>}
    </>
  )
}
